import { toast } from "react-toastify";
import { useEffect, useState } from "react";

import Api from "../../Api";
import { ListCustomAds, NewCustomAdModal } from "../../component";
import { CustomAd } from "../../utils/interface";

const FindCustomAd = () => {
  const api = Api();

  const [ads, setAds] = useState<CustomAd[]>([]);

  const getCustomAds = () => {
    api.customAd.getCustomAds().then((response: any) => {
      console.log(response);
      setAds(response.result.data.customAds);
    })
  }

  const handleCreateCustomAd = (formData: any) => {
    api.customAd.createCustomAd(formData).then((response: any) => {
      toast.success(response.result.message);
      getCustomAds();
    })
  };

  const handleUpdateCustomAd = (customAdId: number, formData: any) => {
    api.customAd.updateCustomAd(customAdId, formData).then((response: any) => {
      toast.success(response.result.message);
      getCustomAds();
    })
  }

  useEffect(() => { getCustomAds() }, []);

  return (<>
    <NewCustomAdModal onSubmit={handleCreateCustomAd} />
    <ListCustomAds ads={ads} onUpdateAd={handleUpdateCustomAd} />
  </>)
};

export default FindCustomAd;
